import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import type { Breadcrumb, User } from '@sentry/react'
import {
  addBreadcrumb as _addBreadcrumb,
  init,
  reactRouterV6BrowserTracingIntegration,
  replayIntegration,
  setUser,
} from '@sentry/react'

/**
 * 监视器
 * 捕获生产异常
 */
function createMonitor() {
  return init({
    release: __APP_VERSION__,
    dsn: import.meta.env.SUITE_SENTRY_DSN,
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration({
        networkDetailAllowUrls: [/^https:\/\/suite-api\.smshan\.cn/],
        networkRequestHeaders: ['authorization'],
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'AbortError: The user aborted a request.',
      'Fetch is aborted',
    ],
  })
}

/**
 * 记录用户信息
 * @param {User}
 * @returns {void}
 */
const traceUser = (info: User) => setUser(info)

/**
 * 记录面包屑
 * @param {Breadcrumb}
 * @returns {void}
 */
const addBreadcrumb = (info: Breadcrumb) => _addBreadcrumb(info)

export type { Breadcrumb }
export { createMonitor, traceUser, addBreadcrumb }
